import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { defaultSettings } from '@hooks/useSettings';
import { request } from '@utils';

interface HookProps {
  tsdId: string;
  messageType: string;
  submittedData?: Record<string, unknown>;
}

export const useTriggerTsdNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tsdId, messageType, submittedData }: HookProps) => {
      await request(
        {
          path: 'admin/trigger-tsd-notification',
          method: 'POST',
          authenticate: true,
          dataObject: {
            tsdId,
            messageType,
            submittedData,
          },
          baseUrl: `${defaultSettings.apiUrl?.replace('/api/v1', '')}/customs-simulator`,
        },
        true,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Simulator notification triggered!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error triggering simulator notification!');
    },
  });
};
